import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TaskIcon(props: IconProps) {
    return <Icon {...props} iconKey={"task"}/>
}
